import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ServiceModule } from './services.module/services.module';
import { KpCommonModule } from './common.component.module/kp-common.module';
import { ElementsModule } from './elements.component.module/elements.module';
import { InsightModule } from './insight.component.module/insight.module';
import { OutsightModule } from './outsight.component.module/outsight.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { SharedModule } from './shared.module/shared.module';
import { RouterOutlet } from '@angular/router';

@NgModule({
    imports: [
        // Angular
        RouterOutlet,
        FormsModule,
        SharedModule.forRoot(),
        // Kreditportal
        ServiceModule,
        KpCommonModule,
        ElementsModule,
        InsightModule,
        OutsightModule
    ],
    exports: [
        // Angular
        RouterOutlet,
        FormsModule,
        SharedModule,
        OAuthModule,
        // Kreditportal
        ServiceModule,
        KpCommonModule,
        ElementsModule,
        InsightModule,
        OutsightModule
    ],
    providers: []
})
export class AppModule {
}
